import { Add } from "@mui/icons-material";
import { Box, Button, Divider, FormControlLabel, FormGroup, Modal, Stack, Switch, TextareaAutosize, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useCreateChannelMutation, useDeleteChannelMutation, useGetChannelsQuery, useUpdateChannelMutation } from "src/app/services/api.generated";
import DataTable from "src/components/organization/DataTable";
import BreadCrumbs from "src/components/organization/layout/breadcrumbs/BreadCrumbs";
import BasicModal from "src/components/ui/Modal";
import { ChannelFileData } from "./ChannelFileData";
import { LoadingButton } from "@mui/lab";

const Channel = () => {
    // delete modal
    const [openDeletModal, setOpenDeleteModal] = useState(false)
    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false)
        setClickedItem(undefined)
        setTitle("")
        setDescription("")
    }
    const handleOpenDeleteModal = () => setOpenDeleteModal(true)
    const [open, setOpen] = useState(false)
    const handleOpenModal = () => setOpen(true)
    const handleClosaModal = () => {
        setOpen(false)
        setClickedItem(undefined)
        setTitle("")
        setDescription("")
    }
    const [clickedItem, setClickedItem] = useState<any>()
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("")
    const [ads, setAds] = useState(false);
    const [hasSecureLink, setHasSecureLink] = useState(false);
    const [secureLink, setSecureLink] = useState("")
    const [secureLinkWithIp, setSecureLinkWithIp] = useState(false)
    const { data: channels, refetch } = useGetChannelsQuery()
    const [deleteChannel, { data: deletResponse, isLoading: deleteLoading }] = useDeleteChannelMutation()
    const [updateChannel, { data: updateResponse, isLoading: updateLoading }] = useUpdateChannelMutation()

    const [createChannel, { data: creatChannelResponse, isLoading: creatChannelLoading, isSuccess }] = useCreateChannelMutation();
    const submit = () => {
        const payload = {
            title: title,
            description: description,
        }
        if (clickedItem) {
            updateChannel({ id: clickedItem._id, data: payload })
        }
        else {
            if (title && description) {
                createChannel(payload)
            }
        }
    }

    useEffect(() => {
        if (isSuccess && creatChannelResponse) {
            setOpen(false)
            refetch()
        }
    }, [creatChannelResponse])

    useEffect(() => {
        if (deletResponse) {
            handleCloseDeleteModal()
            setClickedItem(undefined)
            setTitle("")
            setDescription("")
            refetch()
        }
    }, [deletResponse])

    useEffect(() => {
        if (updateResponse) {
            handleClosaModal()
            setClickedItem(undefined)
            setTitle("")
            setDescription("")
            refetch()
        }
    }, [updateResponse])


    const ActionComponent = (item: any) => {
        return (
            <Stack
                display="flex"
                alignItems="center"
                flexDirection="row"
                gap="6px"
            >
                <Box
                    width="30px"
                    height="30px"
                    onClick={() => {
                        setOpen(true)
                        setTitle(item.title)
                        setDescription(item.description)
                        setClickedItem(item)
                    }
                    }
                    sx={{
                        backgroundColor: "#07bc0c",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#ffffff",
                        cursor: "pointer"
                    }}
                >
                    <i className="fa fa-pencil"></i>
                </Box>
                <Box
                    width="30px"
                    height="30px"
                    onClick={
                        () => {
                            handleOpenDeleteModal()
                            setClickedItem(item)
                        }
                    }
                    sx={{
                        backgroundColor: "#e74c3c",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#ffffff",
                        cursor: "pointer"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Box>
            </Stack>
        )
    }

    const DeleteModal = () => {
        return (
            <Modal
                open={openDeletModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    maxWidth: "100%",
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRaduis: "8px",
                    p: 2,
                }}>
                    <Typography>آیا مطمئنی میخای پاک کنی؟</Typography>
                    <Stack
                        display="flex"
                        alignItems="center"
                        flexDirection="row"
                        marginTop="20px"
                        gap="10px"
                    >

                        <LoadingButton
                            onClick={() => {
                                if (clickedItem) {
                                    console.log(clickedItem)
                                    deleteChannel(clickedItem._id)
                                }
                            }}
                            loading={deleteLoading}
                            variant="contained"
                            sx={{
                                backgroundColor: "#e74c3c",
                                ":hover": {
                                    backgroundColor: "#e74c3c"
                                }
                            }}
                        >
                            بله
                        </LoadingButton>
                        <Button
                            onClick={() => {
                                setOpenDeleteModal(false)
                                setClickedItem(undefined)
                                setTitle("")
                                setDescription("")
                            }}
                            variant="contained"
                        >
                            خیر
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        )
    }

    const convertedChannels =
        channels?.map(c =>
        ({
            ...c,
            createdAt: new Date(c.createdAt).toLocaleDateString("fa-IR"),
            description: c.description.length > 50 ? c.description.substring(0, 50) + "..." : c.description,
            secure_link: Boolean(c.secure_link),
            action: ActionComponent(c)
        }))

    return (
        <>
            {DeleteModal()}
            <Stack
                sx={{ width: "100%" }}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <BreadCrumbs spaceBottom={false} />
                <BasicModal
                    text="افزودن دسته بندی"
                    handleClose={handleClosaModal}
                    handleOpen={handleOpenModal}
                    open={open}
                >
                    <Typography>{clickedItem ? "ویرایش دسته بندی" : "افزودن دسته بندی"}</Typography>
                    <Divider sx={{ margin: "10px 0" }} />
                    <TextField
                        id="outlined-basic"
                        label="عنوان"
                        variant="outlined"
                        size="small"
                        value={title}
                        onChange={(e: any) => {
                            setTitle(e.target.value)
                        }}
                        sx={{
                            padding: "3px",
                            marginTop: "15px",
                            width: "100%"
                        }}
                    />
                    <textarea
                        placeholder="توضیحات"
                        rows={4}
                        value={description}
                        onChange={(e: any) => {
                            setDescription(e.target.value)
                        }}
                        style={{
                            width: "100%",
                            marginTop: "15px",
                            display: "block",
                            resize: "none",
                            padding: "10px"
                        }}
                    ></textarea>
                    {
                        hasSecureLink &&

                        <TextField
                            id="outlined-basic"
                            label="کلید لینک امن"
                            variant="outlined"
                            size="small"
                            value={secureLink}
                            onChange={(e: any) => {
                                setSecureLink(e.target.value)
                            }}
                            sx={{
                                padding: "3px",
                                marginTop: "15px",
                                width: "100%"
                            }}
                        />
                    }
                    <Divider sx={{ margin: "10px 0" }} />
                    <Stack
                        display="flex"
                        alignItems="center"
                        flexDirection="row"
                        gap="8px"
                        marginTop="10px"
                    >
                        <Button
                            variant="contained"
                            onClick={() => {
                                submit()
                            }}
                        >
                            ذخیره
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleClosaModal}
                        >
                            لغو
                        </Button>
                    </Stack>
                </BasicModal>
            </Stack>
            <br />
            <DataTable
                rows={convertedChannels ?? []}
                columns={ChannelFileData}
                title={"دسته بندی ها"}
                pathname={"/channel"}
            />
        </>)
}
export default Channel;